/** @license Copyright (c) 2011 - now Greenwood Mapping, Inc. */
/* global legend_config */

// OpenLayers imports
import {VERSION as olVersion} from '../node_modules/ol/util.js';
import Map from '../node_modules/ol/Map.js';
import View from '../node_modules/ol/View.js';
import Projection from '../node_modules/ol/proj/Projection.js';
import {defaults as defaultControls, ScaleLine} from '../node_modules/ol/control.js';
import {defaults as defaultInteractions} from '../node_modules/ol/interaction.js';
import FormatGeoJSON from '../node_modules/ol/format/GeoJSON.js';


// gwmap imports
import Layers from './Layers.js';
import olLayersSetup from './olLayers.js';
import {changePage} from './changePage.js';
import Layout from './Layout.js';
import CoordSystems from './CoordSystems.js';
import Proj4_rwg from './Proj4_rwg.js';
import Tabs from './Tabs.js';
import SearchTab from './Search.js';
import {dLegend} from '../dlegend/dlegend.js';
import {ScaleLable} from './Scale.js';
import History from './History.js';
import ToolManager from './ToolManager.js';
import dlegendHandler from './dlegendHandler.js';
import Selection from './Selection.js';
import otherMapView from './otherMapView.js';
import Sources from './Sources.js';
import Styles from './Styles.js';
import zoomToExtent from './zoomToExtent.js';
import LightBox from './LightBox.js'

// imports that become rwg globals
import string_wrap from './util/string_wrap.js'
import ajax from './ajax.js';
import {urlParamsToJSON, relocateElementBySelector, hexToRgb} from './util.js';
import SidePanelControl from './SidePanelControl.js';
import SelectionSet from './SelectionSet.js';
import {detailTab, renderInfo} from './renderInfo.js';  // these just get pushed into rwg
import formatInfo from './formatInfo.js';   // this just gets pushed into rwg
import mapFeatures from './mapFeatures.js';  // this just gets pushed into rwg
import zoomToVectorExtents from './zoomToVectorExtents.js';  // this just gets pushed into rwg
import ItemQuery from './ItemQuery.js';  // will create rwg.itemQuery() if config.mapservHilite === true
import {default as formatArea} from './util/polygonArea.js'; // rwg.formatArea() used in cpc conf.js
import Thematic from './Thematic.js';
import clipToExtent from './clipToExtent.js';
import pointInPolyInView from './pointInPolyInView.js';
import pointOnLineInView from './pointOnLineInView.js';
// import {CSCS} from  '../cscs/src/index.js'; // just to make it global for assessor
import mapIt from './mapIt.js'

window.extKey = {}; // for InfoTool compatibility
window.relocateElementBySelector = relocateElementBySelector;
// window.CSCS = CSCS;
window.rwg = {
  FormatGeoJSON: FormatGeoJSON,
  ajax: ajax, // Washakie pubworks & cpc config files still use rwg.ajax
  clipToExtent: clipToExtent, // using pointInPolyInView or pointOnLineInView is probably better in most cases
  pointInPolyInView: pointInPolyInView, // for labeling polygons
  pointOnLineInView: pointOnLineInView, // for labeling linestrings
  SelectionSet: SelectionSet,  // make it available in county config files, should go away, grep -r --include *.js SelectionSet --exclude-dir node_modules /rwg/mnt
  detailTab: detailTab,
  formatInfo: formatInfo,
  mapFeatures: mapFeatures,
  renderInfo: renderInfo,  // make it available in county conf.js
  urlParamsToJSON: urlParamsToJSON,  // make it available in cpc conf.js
  formatArea: formatArea,  // make it available in cpc conf.js
  zoomToVectorExtents: zoomToVectorExtents,  // used in county config files
  hexToRgb: hexToRgb,
};

let map;  // exported by this module

document.addEventListener('DOMContentLoaded', function() {
  init(rwgInitParams)
})

function init(config) {

  mapIt() // this just assigns two mapIt functions to global window object
  string_wrap() // add a wrap() method to the String.prototype

  // register my event handlers before ol registers its becasue my rwg.layout.set intentionally blocks further propogation
  rwg.photoSketch = new LightBox();
  window.addEventListener('resize', rwg.photoSketch.adjustSize )

  rwg.layout = new Layout();
  // rwg.layout.set has event.stopImmediatePropagation() and a setTimeout() which prevents any following 'resize" handlers from firing
  ['resize', 'pageshow'].forEach((e) => window.addEventListener(e, rwg.layout.set, false));

  document.getElementById('mappage').style.display = 'block';  // need the mappage to be visibile to get ol to properly initialize
  window.args = rwg.args = urlParamsToJSON(); // make it accessible to initCode functions. window.args deprecated, rwg.args preferred

  config.defaultImgTyp = config.defaultImgTyp || 'png8'
  config.mapserv = config.mapserv || '/cgi-bin/mapserv.fcgi'
  config.info_url = config.info_url || 'infoTool.php'
  // TO DO: below may create double '&'
  config.info_url += config.info_url.indexOf('?') > 0 ? '&' : '?';  // if info_url already has a "?" in it then append "&" else append "?"
  config.hiliteMethod = config.hiliteMethod || 'vector';
  if (rwg.print !== undefined) config.print = rwg.print;

  if (!rwg.infoLayers && config.infoLayers) rwg.infoLayers = config.infoLayers;

  config.ol_ver = parseFloat(olVersion); // openlayers version
  rwg.config = config;

  // rwg.cs = new CoordSystems(config)
  rwg.proj = new Proj4_rwg(config)  // Proj4js replacement for CoordSystems() which requires rwg CSCS.js

  rwg.selection = new Selection();  // a global container for all selection sets
  for (var sel in config.selectionSets) {
    rwg.selection[sel] = new SelectionSet(config.selectionSets[sel]);
  }
  // convenience - create a default ownership selection set
  if (typeof rwg.selection.ownership === 'undefined') {
    rwg.selection.ownership = new SelectionSet(config.ownershipInfoFormat);
  }

  // initTopTabs();  // jQuery tabs
  // initSideTabs();  // jQuery tabs
  if (!config.hideSearch) {
    new SearchTab();
  }
  rwg.tabs = new Tabs(); // w3s tabs

  // legend_config is usually defined in legend.js or legend-*.js
  // which is created by make_dlegend_json.php, but can be a property of config{}
  // global legend_config in legend.js will overwrite config.dlegend
  if (typeof legend_config !== 'undefined') {
    config.dlegend = legend_config;
  }

  let dlegend = new dLegend();
  dlegend.initialize(
    'legend',  // elementId
    config.dlegend || null,
    dlegendHandler  // call back function
  );
  rwg.layers = new Layers(config, dlegend);  // this has to be after "new dLegend()"
  rwg.dlegend = dlegend;  // used in cpc/htdocs/mapserver/etc/zones-conf.js



  // if a projection is explicitly set add it to the view, otherwise will default to epsg:3857

  if (config.olProjection) {
    config.olView.projection = new Projection(config.olProjection)
    /* // 2024-03-31 removed this in conjunction with switch from rwg.CSCS to porj4js
       // if setGetPointResolution() is necessary it should be added in Proj4_rwg.js
    if (rwg.cs.map.proj === 'tmerc') {
      config.olView.projection.setGetPointResolution(function() {
        return map.getView().getResolution();
      });
    } else {
      console.warn('getPointResolution function not defined, ScaleLine may be incorrect.');
    }
    */
  }
  if (config.fractionalZoom === false) config.olView.constrainResolution = true // I don't think there are any fractionalZoom anymore
  config.olView.constrainOnlyCenter = true // see ol 6.0 upgrade notes https://github.com/openlayers/openlayers/releases/
  // let view = new View(config.olView)

  // config.olView.projection MUST BE CREATED BEFORE CALLING Sources()
  rwg.sources = new Sources(rwg.config.sources);
  rwg.styles = new Styles(rwg.config.styles);
  map = new Map({
    target: 'map-div',
    layers: olLayersSetup(config.olLayers),
    controls: defaultControls({ /* zoom: false, */ /* attribution: false */ })
      .extend([
        new ScaleLine({
          units: 'us',
          // target: document.getElementById('scale-bar')
        })
        /* attribution */
      ]),
    // 2023-01-18 changed moveTolerance from 1 (the default) - the Galaxy S22 is far more responsive to clicks
    moveTolerance: 3, // CAN THIS REPLACE ToolManager.js:map.on('pointerdrag', function(e) ?
    view: new View(config.olView),
    overlays: [],  // overlays are interactive visual element like a control, but tied to a specific geographic position e.g. pop-up
    interactions: defaultInteractions({   // interactions have no visible user interface element e.g. DragPan
      doubleClickZoom: false
    })
  });

  rwg.map = map;
  map.getLayerByTitle = function(title) {
    let lyr = null;
    this.getLayers().forEach(function(l) {
      if (l.get('title') === title) {
        lyr = l;
      }
    })
    return lyr
  }

  map.zoomToExtent = zoomToExtent

  // Only used in Teton & Sweetwater for roads & subdivisions
  // subdivisions seem to hilight w/ vectors in permalink
  if (config.mapservHilite) {
    rwg.itemQuery = new ItemQuery(map);
  }

  map.on('pointermove', evt => rwg.proj.display(evt))

  // historyManager() called in county config files so needs to be rwg.global
  // the constructor:
  //   calls applyUrlArgs(true)
  //   adds map.on('moveend', push)
  //   window.addEventListener('popstate', pop)
  rwg.historyManager = new History(map, dlegend);
  dlegend.clickEnd = rwg.historyManager.push;

  // Expand the legend branch for every active layer. Has to be after new History()
  rwg.layers.getActiveDrawLayers().forEach(lyr => dlegend.expandBranch(lyr))

  new ScaleLable(map, 'scale'); // this needs to be after new History()
  rwg.toolManager = new ToolManager(map); // make it available in rwg so can be accessed in Print.js

  rwg.sidePanel = new SidePanelControl();

  [].forEach.call(  // assign click handler to all 'back' buttons
    document.getElementsByClassName('rwg-btn-back'),  // returns an HTMLCollection, not an array, hence the Array.prototype.forEach.call() above
    function(btn) {
      btn.addEventListener('click', function() { history.back(); });
    }
  );

  let acceptButton = document.getElementById('btn-accept');
  if (acceptButton) {
    acceptButton.addEventListener('click', function() {
      changePage('mappage'); map.updateSize();
    });
  }

  for (let fn in config.initCode) {
    if (typeof config.initCode[fn] === 'function' && config.initCode.hasOwnProperty(fn)) {
      config.initCode[fn]();
    }
  }

  if (config.disclaimer && rwg.layout.get() === 'paged') {
    // NOT using changePage() here so history.back will never go back to the start page
    document.getElementById('mappage').style.display = 'none';
    document.getElementById('startpage').style.display = 'block';
    document.getElementById('disclaimer').innerHTML = config.disclaimer;
  }

  if (config.thematic) {  // cpc only
    config.thematic = new Thematic(config.thematic);
  }

  // https://css-tricks.com/forums/topic/prevent-body-scrolling-when-the-user-scrolls-on-fixed-position-div/
  document.getElementById('mappage')
    .addEventListener('touchmove', function(e) {
      e.preventDefault();
    }, false);

  // ol 6.2 needs this
  document.getElementById('map-div').focus();

}

export {map};
